// API 响应相关类型定义
// API 状态码常量
export const API_CODE = {
    SUCCESS: 0,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    VALIDATION_ERROR: 422,
    SERVER_ERROR: 500,
};
// 订单状态枚举
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PENDING"] = "pending";
    OrderStatus["CONFIRMED"] = "confirmed";
    OrderStatus["IN_TRANSIT"] = "in_transit";
    OrderStatus["DELIVERED"] = "delivered";
    OrderStatus["CANCELLED"] = "cancelled";
})(OrderStatus || (OrderStatus = {}));
// 车辆状态枚举
export var VehicleStatus;
(function (VehicleStatus) {
    VehicleStatus["AVAILABLE"] = "available";
    VehicleStatus["BUSY"] = "busy";
    VehicleStatus["MAINTENANCE"] = "maintenance";
    VehicleStatus["OFFLINE"] = "offline";
})(VehicleStatus || (VehicleStatus = {}));
// 地址类型枚举
export var AddressType;
(function (AddressType) {
    AddressType["HOME"] = "home";
    AddressType["OFFICE"] = "office";
    AddressType["WAREHOUSE"] = "warehouse";
    AddressType["OTHER"] = "other";
})(AddressType || (AddressType = {}));
//# sourceMappingURL=api.js.map